import { useEffect } from 'react'
import { history } from '@mortgage-pos/ui/history'
import newRelic from '@mortgage-pos/ui/services/newRelic'
import { useStoreState, useStoreActions } from '@mortgage-pos/ui/store'

export const useBackButtonNavigation = () => {
  const { active, isStart } = useStoreState((state) => state.questionnaire)

  const { back } = useStoreActions((state) => state.questionnaire)

  useEffect(() => {
    return history.listen((location) => {
      const backActionNotAllowed = ['ntlQualification', 'pricing'].includes(
        active?.name
      )

      // Allows users to go back using the browser back button
      // if they are not on the start or pricing pages
      if (history.action === 'POP' && !backActionNotAllowed && !isStart) {
        newRelic.increment('browser_back_button_click')
        back({})
      }
    })
  }, [active, back, isStart])
}

export default useBackButtonNavigation
